export enum PoolGraphVariant {
  EQUITY = 'equity',
  GRANTED = 'granted',
}
